module.exports = __webpack_public_path__ + "img/sertifikat-2.db8f7c32.jpg";